var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "wrapper",
      staticClass: "process-wrapper __pointer",
      on: { click: _vm._setSize }
    },
    [
      _c(
        "div",
        { staticClass: "line-wrapper" },
        [
          _c(
            "div",
            {
              ref: "line",
              staticClass: "line",
              class: {
                smooth: !_vm.isShowPrecent
              },
              style: { width: _vm.size + "%" }
            },
            [
              _c(
                "div",
                {
                  ref: "drag",
                  staticClass: "drag",
                  on: {
                    mousedown: _vm.pcDrag,
                    mouseenter: _vm.showPercent,
                    mouseleave: _vm.hidePercent
                  }
                },
                [
                  _c(
                    "span",
                    {
                      ref: "percent",
                      staticClass: "percent",
                      class: {
                        show: _vm.isShowPrecent
                      }
                    },
                    [_vm._v(_vm._s(parseFloat(_vm.size).toFixed(2)) + "%")]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("ul", { staticClass: "list" }, [
            _c("li", { ref: "point0" }, [
              _c("span", { class: { active: _vm.size >= 0 } })
            ]),
            _vm._v(" "),
            _c("li", { ref: "point1" }, [
              _c("span", { class: { active: _vm.size >= 25 } })
            ]),
            _vm._v(" "),
            _c("li", { ref: "point2" }, [
              _c("span", { class: { active: _vm.size >= 50 } })
            ]),
            _vm._v(" "),
            _c("li", { ref: "point3" }, [
              _c("span", { class: { active: _vm.size >= 75 } })
            ]),
            _vm._v(" "),
            _c("li", { ref: "point4" }, [
              _c("span", { class: { active: _vm.size >= 100 } })
            ])
          ]),
          _vm._v(" "),
          _vm._t("default")
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }